/**
 * WPN GATEWAY ENTERPRISE WEB ADMIN API' dev
 *
 * API version: 1.0.0
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';

import { CoreApiClientService } from 'pn-core-code';

import { apiBaseUrl } from '../api-base-url';
import { BannerPaginationResponseDto } from '../model/bannerPaginationResponseDto';
import { BannerRequestDto } from '../model/bannerRequestDto';
import { BannerResponseDto } from '../model/bannerResponseDto';
import { ValidationError } from '../model/validationError';

export enum bannersGetPositionEnum {
  tablet_wallpaper = 'tablet_wallpaper',
  admin_wallpaper = 'admin_wallpaper',
}
export enum bannersGetLanguageEnum {
  th = 'th',
  en = 'en',
}

@Injectable({
  providedIn: 'root',
})
export class BannersService {

  constructor(
    protected api: CoreApiClientService) {
  }

  /**
   * [Authorize] type: http
   */
  public bannersGet$(page?: number, limit?: number, position?: string, name?: string, title?: string, startAt?: string, endAt?: string, language?: string, isActive?: boolean, sort?: string): Observable<BannerPaginationResponseDto> {
    return this.api.get(`${apiBaseUrl()}/banners`, { page, limit, position, name, title, startAt, endAt, language, isActive, sort });
  }
  /**
   * [Authorize] type: http
   */
  public bannersIdDelete$(id: string): Observable<string> {
    return this.api.delete(`${apiBaseUrl()}/banners/${encodeURIComponent(String(id))}`, undefined);
  }
  /**
   * [Authorize] type: http
   */
  public bannersIdPut$(id: string, body: BannerRequestDto): Observable<BannerResponseDto> {
    return this.api.put(`${apiBaseUrl()}/banners/${encodeURIComponent(String(id))}`, body, undefined);
  }
  /**
   * [Authorize] type: http
   */
  public bannersIdUpdateIsActivePatch$(id: string): Observable<string> {
    return this.api.patch(`${apiBaseUrl()}/banners/${encodeURIComponent(String(id))}/update-is-active`, undefined, undefined);
  }
  /**
   * [Authorize] type: http
   */
  public bannersPost$(body: BannerRequestDto): Observable<BannerResponseDto> {
    return this.api.post(`${apiBaseUrl()}/banners`, body, undefined);
  }
  /**
   * [Authorize] type: http
   */
  public bannersWallpaperLoginPageGet$(): Observable<BannerResponseDto> {
    return this.api.get(`${apiBaseUrl()}/banners/wallpaper-login-page`, undefined);
  }
}
